import React from 'react'
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import Paginations from '../../common/paginations';
import constant from '../../../constant';

const List = ({ data, setCurrentPage, limit, onChangeAccess }) => {

    const { users, total, page, totalPages } = data;
    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-nowrap table-hover">
                    <thead className="table-light">
                        <tr>
                            <th scope="col" style={{ width: 70 }}>
                                #
                            </th>
                            <th scope="col">User Information</th>
                            <th scope="col">User Name</th>

                            <th scope="col">Email</th>
                            <th scope="col">Mobile</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users?.map((item, index) => {
                            const serialNumber = (page - 1) * limit + index + 1;

                            return (
                                <tr key={item.USER_ID}>
                                    <td>
                                        <div className="avatar-xs">
                                            <span className="avatar-title rounded-circle" style={{ color: 'black' }}>{serialNumber}</span>
                                        </div>
                                    </td>

                                    <td>
                                        <h5 className="font-size-14 mb-1">
                                            <a href="javascript:void(0);" className="text-dark">
                                                {item.FULL_NAME}  <span className={`badge border border-light rounded-circle ${item.LOGIN_STATUS === 'A' ? 'bg-success' : item.LOGIN_STATUS === 'B' ? 'bg-danger' : item.LOGIN_STATUS === 'I' ? 'bg-warning' : ''} p-1`}>
                                                    <span className="visually-hidden" />
                                                </span>
                                            </a>
                                        </h5>
                                        <p className="text-muted mb-0">{item.ROLE_NAME}</p>
                                        <div className="d-flex justify-content-between">
                                            <p className="mb-0 "> <span style={{ fontWeight: '500' }}>Gender: </span>{item.GENDER}</p><br />
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <p className="mb-0"><span style={{ fontWeight: '500' }}>Site: </span>{item.LOCATION_NAME}</p>
                                        </div>

                                    </td>
                                    <td>{item.USER_NAME}</td>

                                    <td>{item.EMAIL_ID}</td>
                                    <td>{item.MOBILE}</td>
                                    <td>
                                        <ul className="list-inline font-size-20 contact-links mb-0">
                                            <li className="list-inline-item px-2">
                                                <Link to={{
                                                    pathname: constant.Authedcomponent.editUser.url,
                                                    state: {
                                                        userData: btoa(JSON.stringify(item)),
                                                        page: page
                                                    }  // Passing the entire `item` object as data
                                                }} title="Edit User">
                                                    <i className="bx bx-edit" />
                                                </Link>
                                            </li>
                                            <li className="list-inline-item px-2">
                                                <a
                                                    href="javascript:void(0);"
                                                    style={{ color: "red" }}
                                                    title={item.LOGIN_STATUS === 'A'?"Archive User":"Restore User"}
                                                    onClick={() => { onChangeAccess(item) }}
                                                >
                                                    <i className={`bx ${item.LOGIN_STATUS === 'A' ? 'bx-check-circle' : 'bx-error-circle'}`} />
                                                </a>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>

                            )
                        })}

                    </tbody>
                </table>
            </div>
            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </React.Fragment>


    )
}

export default withRouter(List)